import axios from "axios"
import checkResponse from "../helpers/responseService"

export default {
  getPaginatedAdvertisers(params) {
    return axios.get('/adv', {
      params: params
    }).then(response => {
      return checkResponse(response)
    })
  },

  getAllAdvertisers() {
    return axios.get('/adv/list')
      .then(response => checkResponse(response))
  },

    getAccountHistory(id) {
        return axios.get('/adv/account-history/' + id)
            .then(response => checkResponse(response))
    },

  saveAdvertiser(advertiser) {

    return axios.post('/adv', advertiser)
      .then(response => response)
      .catch(e => e.response)
      .then(response => checkResponse(response))
  },

  updateAdvertiser(id, data) {
    return axios.put('/adv/' + id, data)
      .then(response => response)
      .catch(e => e.response)
      .then(response => checkResponse(response))
  },

  deleteAdvertiser(id) {

    return axios.delete('/adv/' + id)
      .then(response => {
        return checkResponse(response)
      })
  },

    deleteHistory (id) {
        return axios.delete('/adv/account-history/' + id)
            .then(response => {
                return checkResponse(response)
            })
    },

    saveHistory (id, date) {
        return axios.post('/adv/account-history/' + id, {
          'affected_date': date
        })
            .then(response => {
                return checkResponse(response)
            })
    }
}




// WEBPACK FOOTER //
// ./resources/js/services/advertisersDataService.js